import { render, staticRenderFns } from "./auth-code.vue?vue&type=template&id=53d9b3b2&"
import script from "./auth-code.vue?vue&type=script&lang=js&"
export * from "./auth-code.vue?vue&type=script&lang=js&"
import style0 from "./auth-code.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports